import ExtensionIcon from '@material-ui/icons/Extension';
import JigsawGameList from './components/JigsawGameList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Jigsaw Game',
  subMenuName: 'reports',
};

export default {
  list: JigsawGameList,
  icon: ExtensionIcon,
  name: 'admin/reports/jigsaw-game',
  options,
};
